import React from 'react'

function SignUp() {
    return (
        <div>
        <h1 className="page-title">SIGN UP</h1>
    </div>
    )
}

export default SignUp
